import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MapView from "@/components/MapView";
import PublicSubmitBox from "@/components/PublicSubmitBox";
import AdminLogin from "@/components/AdminLogin";
import AdminDashboard from "@/components/AdminDashboard";
import AdminTicketInbox from "@/components/AdminTicketInbox";
import VendorVerificationList from "@/components/VendorVerificationList";
import VendorSignup from "@/components/VendorSignup";
import VendorLogin from "@/components/VendorLogin";
import VendorDashboard from "@/components/VendorDashboard";
import { Toaster } from "@/components/ui/sonner";

// Re-export API from config for backward compatibility if needed, 
// though direct import from @/config is preferred in components
export { API } from "@/config";

// Protected Route Component
const ProtectedRoute = ({ children, role = null }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  if (!token) {
    // Redirect to appropriate login based on role
    if (role === 'admin') {
      return <Navigate to="/admin/login" replace />;
    }
    return <Navigate to="/vendor/login" replace />;
  }
  
  // Role-based access control
  if (role && user.role !== role) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<MapView />} />
          <Route path="/submit-box" element={<PublicSubmitBox />} />
          
          {/* Vendor Routes */}
          <Route path="/vendor/signup" element={<VendorSignup />} />
          <Route path="/vendor/login" element={<VendorLogin />} />
          <Route 
            path="/vendor/dashboard/*" 
            element={
              <ProtectedRoute>
                <VendorDashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedRoute role="admin">
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/tickets" 
            element={
              <ProtectedRoute role="admin">
                <AdminTicketInbox />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/verifications" 
            element={
              <ProtectedRoute role="admin">
                <VendorVerificationList />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
